<!-- Circular progress indicator overlay for an uploading chat attachment. -->

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps({
  progress: { type: Number, required: true },
});

const circumference = computed(() => 2 * Math.PI * 18);
const strokeDashoffset = computed(() => {
  return circumference.value * (1 - props.progress / 100);
});
</script>

<template>
  <div :class="css.progress">
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
    >
      <circle
        :class="css.circle_background"
        cx="20"
        cy="20"
        r="18"
        fill="none"
        stroke-width="4"
      />
      <circle
        :class="css.circle_progress"
        cx="20"
        cy="20"
        r="18"
        fill="none"
        stroke-width="4"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="strokeDashoffset"
      />
    </svg>
    <span :class="css.percentage">{{ Math.round(progress) }}%</span>
  </div>
</template>

<style lang="scss" module="css">
.progress {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.circle {
  &_background {
    stroke: $color-white;
  }

  &_progress {
    stroke: $color-gray-800;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
    transition: stroke-dashoffset 0.3s ease;
  }
}

.percentage {
  position: absolute;
  font-size: $font-size-10;
  font-weight: 600;
  color: $color-gray-800;
}
</style>
